import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

export default function Blank({ post, blankresults, expend }: any) {
	let ones
	post.map((e: any) => {
		e.order_detail.map((a: any) => {
			ones = a.results[0]
			return undefined
		})
		return undefined
	})

	if (blankresults !== null && blankresults.length > 0) {
		ones = blankresults
	}

	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label='simple table'>
				<TableHead sx={{ bgcolor: 'primary.main' }}>
					<TableRow>
						{blankresults !== null && ones !== null ? (
							Object.keys(ones[0]).map((key: string, idx: number) => (
								<TableCell key={idx} sx={{ color: 'white', fontWeight: '700' }}>
									{key === 'name'
										? 'Անվանում'
										: key === 'result'
										? 'Արդյունք'
										: key === 'norm_text'
										? 'Նորմա'
										: key === 'unit'
										? 'Միավոր'
										: key}
								</TableCell>
							))
						) : (
							<TableCell colSpan={5}></TableCell>
						)}
					</TableRow>
				</TableHead>
				<TableBody>
					{blankresults !== null ? (
						blankresults.map((row: any, index: number) => {
							return (
								<TableRow key={index}>
									{Object.keys(row).map((key: string) => (
										<TableCell key={key}>{row[key]}</TableCell>
									))}
								</TableRow>
							)
						})
					) : (
						<TableRow>
							<TableCell colSpan={5}></TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
